import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import ClubHome from "@/pages/ClubHome";
import MyAccount from "@/pages/MyAccount";
import Admin from "@/pages/Admin";
import CookiePolicy from "@/pages/CookiePolicy";
import { CookieConsent } from "@/components/CookieConsent";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ClubHome />} />
          <Route path="/akce/detailing" element={<Landing />} />
          <Route path="/muj-ucet" element={<MyAccount />} />
          <Route path="/zasady-cookies" element={<CookiePolicy />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/scan/:code" element={<Admin />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default App;
